// extracted by mini-css-extract-plugin
module.exports = {"item":"a10a3f92e9--item--wev3W","title":"a10a3f92e9--title--gnIkq","content":"a10a3f92e9--content--AKqsy","icon":"a10a3f92e9--icon--HNp_U"};